import { BILL_TYPE } from '$business/enums/options';
import { INPUT, INPUT_TYPES } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { input } from '$ghelpers';
import { validateEmail } from '$ghelpers/input';

export const PAYMENT_REQUEST_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        label: 'INPUT.LABEL.BILL.BILL_TYPE',
        value: 'invoiceType',
        input: INPUT.SELECT,
        options: BILL_TYPE,
        gridSize: 6,
        size: 'small',
        validation: [input.requiredValidation],
      },
      {
        ...INPUT_TYPES.EMAIL,
        label: 'INPUT.LABEL.BILL.EMAIL',
        value: 'email',
        gridSize: 6,
        size: 'small',
        validation: [
          input.requiredValidation,
          {
            condition: v => !validateEmail(v),
            message: 'INVALID_EMAIL',
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'INPUT.LABEL.BILL.CUSTOMER_CODE',
        value: 'customerCode',
        input: INPUT.NUMBERTEXT,
        maxLength: 10,
        gridSize: 6,
        size: 'small',
        onBlur: async ({ value, callback }) => {
          callback(value);
        },
        validation: [
          input.requiredValidation,
          {
            condition: v => {
              return v.length < 4;
            },
            message: 'LENGTH_OVER',
          },
        ],
      },
      {
        label: 'INPUT.LABEL.BILL.ADDRESS',
        value: 'address',
        input: INPUT.TEXT,
        gridSize: 6,
        size: 'small',
      },
    ],
  },
  {
    items: [
      {
        ...INPUT_TYPES.ZIP,
        label: 'INPUT.LABEL.BILL.ZIP',
        gridSize: 6,
        size: 'small',
      },
      {
        ...INPUT_TYPES.AMOUNT,
        gridSize: 6,
        size: 'small',
        validation: [input.requiredValidation],
      },
    ],
  },
];

export default PAYMENT_REQUEST_FORM;
